import store from '@garmin/support-center-components/app/store/store';
import initSupportStoreModuleAviationOTC from '@garmin/support-store-modules/src/store/modules/aviationOTC';
import session from './modules/session';
import { capi } from './client';

store.registerModule('session', session);
store.registerModule('aviationOTC', initSupportStoreModuleAviationOTC({
  service: capi, opts: { moduleNamespace: 'aviationOTC', bypassNamespace: true },
}));

export default store;
